// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zjjB","label":"styles_label__1WdiG"};